import { React } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectTvFilmRadioFetchResults, selectTvFilmRadioFetchRequest, selectAvCurrentPage, selectAvTotalPages, selectTvFilmRadioAvRows, selectTvFilmRadioAvFirst, selectTvFilmRadioFetchStatus, selectAvFilter, selectAvSort } from 'components/Body/Search/SearchResultsPanels/store/selectors'
import { setTvFilmRadioFetchStatusAction, setTvFilmRadioFetchResultsAction, setAvTotalPagesAction, setAvFirstAction, setAvRowsAction, setAvCurrentPageAction, setAvExcelExportAction, setAvCsvExportAction, setAvFilterAction, setAvSortAction } from './store/actions'
import { selectAvApiHost } from 'globalSelectors'
import { LazyGrid, CopyFieldTemplate } from 'components/common'
import ContributorNameBodyTemplate from 'components/common/CommonGrids/Columns/ContributorNameBodyTemplate'
import BadgeBodyTemplate from 'components/common/CommonGrids/Columns/BadgeBodyTemplate'
import 'primeicons/primeicons.css'
import { Button } from 'primereact/button'
import { Badge } from 'primereact/badge'
import { push } from 'redux-first-history'
import { FilterMatchMode } from 'primereact/api'
import FullTextSearch from 'api/FullTextSearch'
import { fileDownload } from 'api/FileDownload/fileDownload'
import { isFilmByFormatId } from 'modules/Constants'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Checkbox } from 'primereact/checkbox'
import { getOrangeBadgeClass } from 'components/common/CommonGrids/utils/badgeUtils'

const csvDownloadPathSuffix = '/search/csvexport?searchTerm='
const csvDownloadName = 'AudioVisual.csv'
const excelDownloadPathSuffix = '/search/excelexport?searchTerm='
const excelDownloadName = 'AudioVisual.xlsx'

export function AudioVisual(props) {
const searchAvResults = useSelector(selectTvFilmRadioFetchResults)
const currentPage = useSelector(selectAvCurrentPage)
const first = useSelector(selectTvFilmRadioAvFirst)
const rows = useSelector(selectTvFilmRadioAvRows)
const filter = useSelector(selectAvFilter)
const sort = useSelector(selectAvSort)
const originalQuery = useSelector(selectTvFilmRadioFetchRequest)
const avApiHost = useSelector(selectAvApiHost)

const dispatch = useDispatch()
    const queryParamsObject = {}

    if (filter) {
        queryParamsObject.filter = filter.toString()
    }

    if (sort) {
        queryParamsObject.sortBy = sort.toString()
    }

    const queryParams = new URLSearchParams(queryParamsObject).toString()
    const encodedTerm = encodeURIComponent(originalQuery.term + '*')
    const csvDownloadPath = `${avApiHost}${csvDownloadPathSuffix}"${encodedTerm}"&${queryParams}`
    const excelDownloadPath = `${avApiHost}${excelDownloadPathSuffix}"${encodedTerm}"&${queryParams}`
    let avResultList = []
    let avSearchResultsCount = 0

    if (searchAvResults) {
        avResultList = searchAvResults['results']
        avSearchResultsCount = searchAvResults['total']
    }
    const displayType = (rowData) => {
        return <i className={rowData.iconId === 1 ? "fa-light fa-tower-cell" : rowData.iconId === 2 ? "fa-light fa-film" : rowData.iconId === 3 ? "fa-light fa-tv-retro" : "fa-light fa-question"} />
    }

    const navigateTo = route => {
        dispatch(push(route)) // Dispatch action to navigate to the specified route
    }

    const handleEpisodeNavigation = (rowData) => {
        navigateTo(`/AudioVisual/${rowData.programmeId}/${rowData.episodeId}`)
    }

    const displayEpisode = function (rowData, field) {
        return (
            <div id={props.id + '_avList_commonGrid_' + field} className="d-flex justify-content-start align-items-center">
                {rowData[field]}
                <div className="d-flex ml-auto">
                    <Button icon="pi pi-copy" className="white ml-2" rounded onClick={() => navigator.clipboard.writeText(rowData[field])} />
                    <Button className="white ml-2" icon="fa-light fa-arrow-up-right" rounded onClick={() => handleEpisodeNavigation(rowData)} />
                </div>
            </div>
        )
    }

    const displayEpisodeTitle = function (rowData) {
        return displayEpisode(rowData, 'episodeTitle')
    }

    const displayEpisodeCode = function (rowData) {
        return displayEpisode(rowData, 'episodeCode')
    }

    const handleProgrammeNavigation = (rowData) => {
        navigateTo(`/AudioVisual/${rowData.programmeId}${isFilmByFormatId(rowData.formatId) ? `/${rowData.episodeId}` : ''}`)        
    }

    const displayProgramme = function (rowData, field) {
        return (
            <div id={props.id + '_avList_commonGrid_' + field} className="d-flex justify-content-start align-items-center">
                {rowData[field]}
                <div className="d-flex ml-auto">
                    <Button icon="pi pi-copy" className="white ml-2" rounded onClick={() => navigator.clipboard.writeText(rowData[field])} />
                    <Button className="white ml-1" icon="fa-light fa-arrow-up-right" rounded onClick={() => handleProgrammeNavigation(rowData)} />
                </div>
            </div>
        )
    }

    const displayProgrammeTitle = function (rowData) {
        return displayProgramme(rowData, 'programmeTitle')
    }

    const displayProgrammeCode = function (rowData) {
        return displayProgramme(rowData, 'programmeCode')
    }

    const displayIdaCode = function (rowData) {
        return displayIda(rowData, 'episodeIda')    
    }

    const displayEpisodeNumber = function (rowData) {
        return isFilmByFormatId(rowData.formatId) ? 'NA' : rowData.episodeNumber;
    }

    const displaySeriesNumber = function (rowData) {
        return isFilmByFormatId(rowData.formatId) ? 'NA' : rowData.episodeSeries;
    }

    const displayIda = function (rowData, field) {
        return CopyFieldTemplate(rowData, field, props.id + '_avList_commonGrid_' + field)
    }

    const displayActions = function (rowData) {
        return (
            <div id={props.id + '_avList_commonGrid_actions'}>
            </div>
        )
    }


    const header = (
        <div>
            <div className="row d-flex justify-content-flexend">
                <div className="col mt-1">
                    <Badge value={`${first + 1}-${Math.min(first + rows, avSearchResultsCount)}`}> </Badge>
                    <span class="mr-2" style={{ fontSize: "14px", fontWeight: "500", color: "black" }}> <b>of</b> </span>
                    <Badge value={avSearchResultsCount}> </Badge>
                    <span class="mr-2" style={{ fontSize: "14px", fontWeight: "500", color: "black" }}> <b>Results</b> </span>
                </div>

                <div className="col-auto">
                    <Button
                        id={props.id + '_container_dataTable_export_csv'}
                        className="mr-3 ml-2"
                        icon="fa-light fa-file-import"
                        label="CSV Export"
                        onClick={() => fileDownload(csvDownloadPath, csvDownloadName)}
                    >
                    </Button>
                    <Button
                        id={props.id + '_container_dataTable_export_excel'}
                        label="Excel Export"
                        icon="fa-light fa-file-import"
                        onClick={() => fileDownload(excelDownloadPath, excelDownloadName)}
                    >
                    </Button>
                </div>
            </div>
        </div>
    )

    const contributionsExpansionTemplate = (data) => {

        const formatMinutes = (rowData) => {
            return rowData.minutes ? parseFloat(rowData.minutes.toFixed(2)) : ''
        }

        const formatBoolean = (rowData, field) => {
            return <Checkbox checked={rowData[field] || false} disabled={true} />
        }

        const formatMembershipTypes = (rowData) => {
            const memberships = rowData.memberships
            if (!memberships || !Array.isArray(memberships) || memberships.length === 0) {
                return null
            }
            
            return (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem', alignItems: 'center' }}>
                    {memberships.map((membership, index) => (
                        <Badge 
                            key={index} 
                            value={membership.membershipTypeName} 
                            className={`custom-badge-base ${getOrangeBadgeClass(membership.membershipTypeId)}`} 
                        />
                    ))}
                </div>
            )
        }

        const formatAuthorKey = (rowData) => CopyFieldTemplate(rowData, 'authorKey')
        const formatIpiNumber = (rowData) => CopyFieldTemplate(rowData, 'ipiNumber')

        const formatContributorName = (rowData) => (
            <ContributorNameBodyTemplate rowData={rowData} field="name" />
        )

        return (
            <div id={props.id + '_avList_commonGrid_nestedTable'} className="p-3">
                <DataTable value={data.contributions} scrollable scrollHeight="430px" emptyMessage="No Contributors">
                    <Column field="authorKey" header="Author Key" body={formatAuthorKey}></Column>
                    <Column field="name" header="Contributor Name" body={formatContributorName}></Column>
                    <Column field="contributionType" header="Contribution"></Column>
                    <Column field="percentage" header="Percent (%)"></Column>
                    <Column field="minutes" header="Minutes Worked" body={formatMinutes}></Column>
                    <Column field="ipiNumber" header="IPI No" body={formatIpiNumber} className="ipi-column"></Column>
                    <Column field="isPublicDomain" header="Public Domain" body={(rowData) => formatBoolean(rowData, 'isPublicDomain')}></Column>
                    <Column field="isExcluded" header="Excluded" body={(rowData) => formatBoolean(rowData, 'isExcluded')}></Column>
                    <Column field="membershipTypes" header="Membership Types" body={formatMembershipTypes}></Column>
                </DataTable>
            </div>
        )
    }

    const avColumnDefinitions = [
        { columnType: 'programmetype', title: 'Type', mapsToField: 'iconId', template: displayType, filter: true, sortable: true },
        { columnType: 'text', title: 'Programme Code', mapsToField: 'programmeCode', filter: true, template: displayProgrammeCode, sortable: true },
        { columnType: 'text', title: 'Programme Title', mapsToField: 'programmeTitle', template: displayProgrammeTitle, filter: true, sortable: true },
        { columnType: 'text', title: 'Episode Code', mapsToField: 'episodeCode', filter: true, template: displayEpisodeCode, sortable: true },
        { columnType: 'text', title: 'Episode Title', mapsToField: 'episodeTitle', filter: true, template: displayEpisodeTitle, sortable: true },
        { columnType: 'numeric', title: 'Episode No', mapsToField: 'episodeNumber', filter: true, template: displayEpisodeNumber, filterMatchMode: FilterMatchMode.EQUALS, sortable: true },
        { columnType: 'numeric', title: 'Series No', mapsToField: 'episodeSeries', filter: true, template: displaySeriesNumber, filterMatchMode: FilterMatchMode.EQUALS, sortable: true },
        { columnType: 'year', title: 'Year Produced', mapsToField: 'episodeYear', filterMatchMode: FilterMatchMode.EQUALS, filter: true, sortable: true },
        { columnType: 'idaCode', title: 'Ep IDA No', mapsToField: 'episodeIda', template: displayIdaCode, filterMatchMode: FilterMatchMode.EQUALS, filter: true, sortable: true },
        {
            columnType: 'expander',
            title: 'Contributors',
            mapsToField: 'Contributors',
            sortable: false,
            filter: false,
            template: displayActions,
            expand: (rowData) => rowData.contributions?.length
        }
    ]

    return (
        <div id={props.id + '_avList'} >
            <FullTextSearch
                id={props.id + '_container_results_FullTextSearch'}
                key={currentPage + selectTvFilmRadioAvRows}
                setStatusAction={setTvFilmRadioFetchStatusAction} // Use the provided action for fetching results
                setResultsAction={setTvFilmRadioFetchResultsAction}
                requestSelector={selectTvFilmRadioFetchRequest}
            />
            <LazyGrid
                id={props.id + '_avList_commonGrid'}
                keyColumnName="id"
                data={avResultList}
                totalCount={avSearchResultsCount}
                emptyMessage="No Results"
                columnDefinitions={avColumnDefinitions}
                selectTotalPages={selectAvTotalPages}
                selectFirst={selectTvFilmRadioAvFirst}
                selectRows={selectTvFilmRadioAvRows}
                fetchStatusSelector={selectTvFilmRadioFetchStatus}
                setTotalPagesAction={setAvTotalPagesAction}
                setCurrentPageAction={setAvCurrentPageAction}
                setFirstAction={setAvFirstAction}
                setRowsAction={setAvRowsAction}
                setFilterAction={setAvFilterAction}
                setSortAction={setAvSortAction}
                currentPage={currentPage}
                filter={filter}
                sort={sort}
                header={header}
                csvDownloadPath={csvDownloadPath}
                csvDownloadName={csvDownloadName}
                excelDownloadPath={excelDownloadPath}
                excelDownloadName={excelDownloadName}
                rowExpansionTemplate={contributionsExpansionTemplate}
                collapsedRowIcon="pi pi-users" //"fa-light fa-chevron-up"  
                expandedRowIcon={(row, expandedRows) =>
                    <i className={`pi pi-users ${expandedRows && expandedRows.includes(row) ? 'custom-expanded' : ''}`} />
                }
            />
        </div>
    )
}
